
// some constants needed anywhere in the app

export const TTL_TIME_LAPSE = 300000; // 3 minutes ! attention à ce que ce soit bien 3000 un chiffre et non '3000'

export const API_BASE_URL = 'https://ws.cinevauban.fr/api/';